export default {
    translation: {
        title: "美洲",
        applications: "应用程序",
        full_text: "全文",
        vehicle: {
            status: "以每小时{{speed}}英里向{{direction}}方向行驶"
        },
        talkie: {
            drivers_nearby_singular: "附近有1名司机",
            drivers_nearby_plural: "附近有{{count}}名司机"
        },
        settings: {
            save_progress_description:
                "将进度保存到软盘以进行备份或在计算机之间传输。",
            save_progress_action: "保存进度",
            load_progress_action: "加载进度...",
            display_units: "显示单位",
            imperial: "英制",
            metric: "公制",
            start_over_description:
                "提前结束旅程。当前进度将被清除。此操作无法撤销。",
            start_over_action: "重新开始"
        },
        feedback: {
            message: "消息",
            contact_info: "联系方式（可选）",
            send: "发送",
            sending: "发送中..."
        },
        radio: {
            no_reception: "该地区无法接收广播",
            low_signal: "信号弱",
            turn_off: "关闭",
            turn_on: "开启",
            next_station: "下一电台",
            unmute: "取消静音",
            mute: "静音"
        },
        photos: {
            source: "来自Mapillary",
            empty: "正在探索周围以拍摄照片..."
        },
        news: {
            loading: "正在查看当地新闻...",
            nothing_found: "未找到任何内容。"
        },
        metrics: {
            duration_title: "驾驶时间",
            duration_value: "{{days}}天{{hours}}小时{{minutes}}分钟",
            distance_title: "行驶距离",
            emissions_title: "尾气CO2",
            emissions_value_g: "{{g}}克",
            emissions_value_kg: "{{kg}}千克",
            states_visited_title: "访问过的州",
            cairns_discovered_title: "发现的石堆",
            exploration_title: "探索"
        },
        compass: {
            north_east: "东北",
            east: "东",
            south_east: "东南",
            south: "南",
            south_west: "西南",
            west: "西",
            north_west: "西北",
            north: "北"
        },
        landing: {
            about_title: "关于",
            start_title: "开始",
            features_title: "特色",
            about_headline: "美洲：浏览器中的公路旅行模拟器",
            about_paragraph_1:
                "Safari、Chrome、Edge。这些是通往网络无限角落的门户。\n"
                + "美洲是你通往另一种广阔地形的门户：美国\n"
                + "的自然奇观。以你自己的节奏，有无数值得学习的东西。",
            about_paragraph_2:
                "从壮丽的景观到安静的路边时刻，你通过桌面风格的窗口界面\n"
                + "来操控旅程：地图、直播广播、百科全书文章、相册、指标、\n"
                + "日志等。没有记分板，不用着急：意外发现和氛围优先。\n"
                + "在现代浏览器中打开即可，无需安装。",
            about_paragraph_3:
            "你的旅程可以沿着太平洋海岸公路，沿着66号公路穿过平原，穿过落基山脉前往国家公园，"
                + "或在新英格兰的乡间小路上漫游。每到一个地方，都会展开当地的故事：这座城镇、峡谷或"
                + "观景点见证了些什么，电台在播放什么，此刻天气如何。这是一款在浏览器中按自己的节奏"
                + "探索美国的公路旅行模拟器，适用于任何设备。",

            trips_title: "按旅行探索",
            trips_list: [
                { label: "虚拟公路旅行", url: "/virtual-road-trip/" },
                { label: "美国公路旅行", url: "/us-road-trip/" },
                { label: "国家公园公路旅行", url: "/national-parks-road-trip/" },
                { label: "66号公路旅行", url: "/route-66-road-trip/" },
                { label: "探索美洲", url: "/explore-america/" },
                { label: "穿越美国的公路旅行", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "观看广告",
            start_cta: "开始旅程",
            start_cta_lead: "无需安装。在浏览器中运行。",
            features_lede:
                "旅程开始后，你可以从美洲的公路旅行套件中配置仪表盘。\n"
                + "每个窗口都是体验这个国家的不同方式。从当地广播到其他\n"
                + "司机的对讲机，你每次旅行都会发现新的东西。",
            features_list: [
                "可在美国全境进行路由和探索的地图",
                "流媒体广播和与地点相关的文章和照片",
                "日志、指标、相册和百科全书",
                "朋友、语音聊天和共享的路边地标（石堆）",
                "在手机或桌面上通过浏览器运行；无需下载"
            ],
            media_alt: "美洲完整版：软件盒和CD",
            slideshow_alt: "美洲模拟器的公路旅行风景照片，图片",
            og_title: "美洲：公路旅行模拟器",
            og_description:
                "在桌面风格的趣味公路旅行模拟器中探索美国的自然奇观。地图、广播、日志和意外发现，直接在您的浏览器中提供。",
            twitter_description:
                "在桌面风格的趣味公路旅行模拟器中探索美国的自然奇观。无需安装。",
            meta_description:
                "美洲是浏览器中的公路旅行模拟器：通过地图、广播、照片和桌面风格界面，以你自己的节奏探索美国的自然奇观。无需下载；在线开始你的旅程。",
            jsonld_description:
                "美洲是浏览器中的公路旅行模拟器：通过地图、广播、照片和桌面风格界面，以你自己的节奏探索美国的自然奇观。无需下载；在线开始你的旅程。",
            jsonld_genre: ["公路旅行模拟器", "探索游戏", "浏览器游戏"],
            page_title: "美洲：公路旅行模拟器 | 在浏览器中探索美国",
            html_lang: "zh",
            og_locale: "zh_CN",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "de_DE", "ru_RU", "ja_JP", "ko_KR", "pt_BR"],
            og_image_alt: "美洲公路旅行模拟器截图",
            twitter_image_alt: "美洲公路旅行模拟器截图",
        },
    }
};
